import { useMainStore } from '~/store'

export default defineNuxtPlugin(async () => {
  const store = useMainStore()

  await Promise.all([
    store.getMMData(""),
    store.getMMData("homepage"),
    store.getMMData("stores"),
    store.getMMData("promotions"),
    store.getMMData("events"),
    store.getMMData("jobs"),
    store.getMMData("blogs"),
    store.getMMData("news"),
    store.getMMData("hours"),
    store.getMMData("banners"),
    store.getMMData("galleries"),
    store.getMMData("categories"),
    store.loadAuthInfo(),
    // store.getMMData("events", {include_expired:true}),
  ])
})